import { ReactElement } from 'react';
import { config } from 'config';
import { getMobileOperatingSystem, getAppStoreUrl } from 'app/utils/utils';
import { useIsMobile } from 'app/utils/hooks';
import { mobileCompatibleRoutes } from 'app/routing/routesConfig';
import { useLocation, useNavigate } from 'react-router-dom';
import { UnsupportedMobileComponent } from './UnsupportedMobileComponent';

interface UnsupportedMobileProps {
  children?: ReactElement | null;
}

const ROOT_PATH = '/';

export const UnsupportedMobile = ({
  children = null,
}: UnsupportedMobileProps) => {
  const isMobile = useIsMobile();
  const mobileOperatingSystem = getMobileOperatingSystem();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (
    config.isElectronBuild ||
    !isMobile ||
    mobileCompatibleRoutes.includes(pathname) ||
    pathname === ROOT_PATH
  ) {
    return children;
  }

  const appStoreUrl = getAppStoreUrl(mobileOperatingSystem);

  if (appStoreUrl) {
    navigate(-1);
    setTimeout(() => window.location.replace(appStoreUrl));
    return null;
  }

  return isMobile ? <UnsupportedMobileComponent /> : children;
};
